//  是/否
export enum ONE_TWO {
  //  是
  ONE = 1,
  //  否
  TWO = 2,
}
